import Lang from 'ln/lang/Lang';
import Course from './Course';
import CourseElement from './CourseElement';
import FeedbackSequenceModel from '../models/FeedbackSequenceModel';


class FeedbackSequence extends CourseElement {
	
	constructor( public model:FeedbackSequenceModel, private courseView: Course ) {
		super( model, courseView );
	}
	
	public init(){
		super.init();

        this.model.course.change.add( this.updateUrlsByKey.bind(this) );
		this.model.course.sequences.first().change.add( this.updateUrlsByKey.bind( this ) )
        this.model.course.guestusers.added.add( this.updateUrls.bind( this ) );
        this.model.course.guestusers.removed.add( this.updateUrls.bind( this ) );

		this.renderDisplayTime();

		this.blankLinks();

	}

	protected renderDisplayTime() {
		this.node.js('display-time').html = this.model.displayTime + ' ' + Lang.translate( 'processplan.time' );
	}

	private updateUrlsByKey( key, value ){
		if( key == 'title' || key == 'location' || key == 'date' || key == 'customer' || key == 'time' ){
			this.updateUrls();
		}
	}

    private updateUrls(){
		let aTag = this.node.js( 'feedback-url' ).native as HTMLAnchorElement;
		aTag.href = this.model.feedbackUrl;

		let imgTag = this.node.js( 'qr-code' ).native as HTMLImageElement;
		imgTag.src = this.model.qrCodeUrl;
    }


}

export default FeedbackSequence;